import Styled from "styled-components";

export const HeaderHeight = Styled.header`
`;

export const HeaderMenu = Styled.div`
`;

export const HeaderButton = Styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  width: 44px;
  height: 44px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;

  svg {
    height: 24px;
    width: 24px;
    color: white !important;
  }
`;

export const ContainerMenuHamburguer = Styled.aside`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButtonContainer = Styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Space = Styled.div`
`;

export const Container = Styled.div`
    align-items: center;
`;
export const Logo = Styled.img`
`;

export const Balance = Styled.div`
`;
export const H5 = Styled.h6`
`;

export const Block = Styled.div`
  &.header-top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;

    .header-left {
      display: flex;
      align-items: center;

      .logo-wl {
        cursor: pointer;
        max-width: 250px;
        max-height: 41px;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
`;

export const SearchBarContainer = Styled.div`
  background-color: #FFFFFF;
  height: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 24px;
`;

export const SearchInput = Styled.div`
  background-color: #E9E9E9;
  height: 36px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 8px;
  cursor: text;

  svg {
    width: 20px;
    height: 20px;
    color: #595959;
    flex-shrink: 0;
  }

  input {
    border: none;
    background: none;
    outline: none;
    font-size: 14px;
    color: #595959;
    line-height: 1.5;
    width: 100%;
    font-family: var(--font-family);

    &::placeholder {
      color: #595959;
    }
  }
`;

export const P = Styled.p`
`;
